import BrButton from '@govbr/react-components/lib/BrButton';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import imgFundo from '../../assets/img/como-cadastrar-fundo.svg';
import imgPagina1 from '../../assets/img/como-cadastrar-pagina1.svg';
import imgMoca1 from '../../assets/img/como-cadastrar-moca1.svg';
import imgPagina2 from '../../assets/img/como-cadastrar-pagina2.svg';
import imgMoca2 from '../../assets/img/como-cadastrar-moca2.svg';
import imgPagina3 from '../../assets/img/como-cadastrar-pagina3.svg';
import imgPagina4 from '../../assets/img/como-cadastrar-pagina4.svg';
import imgMoca3 from '../../assets/img/como-cadastrar-moca3.svg';
import Card from '../../components/Card/Card';
import styles from './ComoCadastrar.module.css';
import config from '../../envConfig';
import { getDecursoPrazo, selectDecursoPrazo } from '../Suporte/SuporteSlice';
import { useAppDispatch, useAppSelector } from '../../app/hooks';

const ComoCadastrar: React.FC<any> = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();

  const [page, setPage] = useState(1);

  const decursoPrazo = useAppSelector(selectDecursoPrazo);

  useEffect(() => {
    dispatch(getDecursoPrazo());
  },[])

  const pagina1 = (
    <div className={styles.container}>
      <div className={styles.containerScrollable}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>Para se cadastrar</div>
          <i className={`fas fa-times ${styles.close}`} onClick={() => history.goBack()}/>
        </div>
        <div className={styles.content}>
          <Card className={styles.card1}>
            <span>
             <p> Qualquer família de baixa renda pode se cadastrar no Cadastro Único, é de graça! </p>
              <p>O cadastro é feito pessoalmente, num posto de atendimento na cidade onde a família mora.</p>
             <p> O(a) Responsável Familiar (RF) pela família precisa ir ao local de atendimento para fazer o cadastro, levando os documentos de todas as pessoas da família que moram com ela. </p>
             <p> Cada pessoa deve estar cadastrada com a sua família. </p>
            </span>
          </Card>
          <img className={styles.imgPagina1} src={imgPagina1} alt="Imagem do rodapé" />
          <img className={styles.imgMoca1} src={imgMoca1} alt="Mulher em pé" />
        </div>
        <div className={styles.footer}>
          <div className={styles.botaoWrapper}>
            <BrButton className={styles.botao} onClick={() => setPage(2)}>
              Próximo
            </BrButton>
            <div className={styles.bulletPointWrapper}>
              <div onClick={() => setPage(1)} className={`${styles.bulletPoint} ${styles.selecionado}`}></div>
              <div onClick={() => setPage(2)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(3)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(4)} className={styles.bulletPoint}></div>
            </div>
          </div>
        </div>
        <img className={styles.imgFundo} src={imgFundo} alt="Imagem de fundo" />
      </div>
    </div>
  );

  const pagina2 = (
    <div className={styles.container}>
      <div className={styles.containerScrollable}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>Para se cadastrar</div>
          <i className={`fas fa-times ${styles.close}`} onClick={() => history.goBack()}/>
        </div>
        <div className={styles.content}>
          <Card className={styles.card2}>
            <span>
              <span>
                <p> O(a) <strong>Responsável Familiar (RF)</strong> é a pessoa da família que vai prestar as informações de todos os integrantes da família para o entrevistador do Cadastro Único. Essa pessoa precisa ter pelo menos <strong>16 anos</strong> e, preferencialmente, ser <strong>mulher</strong>. </p>
              </span>
            </span>
          </Card>
          <Card className={`${styles.card2} ${styles.secondary}`}>
            <span>
              <p> Em alguns casos, uma família pode também ser cadastrada por um <strong>Representante Legal (RL)</strong>, que é um tutor, curador ou guardião responsável por pessoas que não conseguem se cadastrar sozinhas, como <strong>crianças ou adolescentes menores de 16 anos</strong> ou adultos incapazes que vivem em instituições de acolhimento.</p>
              <p> Famílias representadas por RL também devem se cadastrar apenas no CRAS ou posto de atendimento do Cadastro Único. </p>
            </span>
          </Card>
          <img className={styles.imgPagina2} src={imgPagina2} alt="Imagem do rodapé" />
          <img className={styles.imgMoca2} src={imgMoca2} alt="Mulher em pé" />
        </div>
        <div className={styles.footer}>
          <div className={styles.botaoWrapper}>
            <BrButton className={styles.botao} onClick={() => setPage(3)}>
              Próximo
            </BrButton>
            <div className={styles.bulletPointWrapper}>
              <div onClick={() => setPage(1)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(2)} className={`${styles.bulletPoint} ${styles.selecionado}`}></div>
              <div onClick={() => setPage(3)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(4)} className={styles.bulletPoint}></div>
            </div>
          </div>
        </div>
        <img className={styles.imgFundo} src={imgFundo} alt="Imagem de fundo" />
      </div>
    </div>
  );

  const pagina3 = (
    <div className={styles.container}>
      <div className={styles.containerScrollable}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>Documentos necessários</div>
          <i className={`fas fa-times ${styles.close}`} onClick={() => history.goBack()} />
        </div>

        <div className={styles.content}>
          <Card className={styles.card2}>
            <div>
              <p><strong>Responsável Familiar (RF)</strong></p>
              <ul>
                <li>CPF</li>
                <li>Comprovante de endereço, preferencialmente a conta de luz. <p>Na falta deste, declaração de residência assinada pelo RF.</p></li>
              </ul>
              <p><strong>Outras pessoas da família:</strong></p>
              <ul>
                <li>CPF</li>
              </ul>
              <p><strong>Outros documentos facultativos:</strong></p>
              <ul>
                <li>Título de eleitor</li>
                <li>Certidão de nascimento</li>
                <li>Certidão de casamento</li>
                <li>Carteira de identidade (RG)</li>
                <li>Carteira de trabalho</li>
              </ul>
            </div>
          </Card>

          <Card className={`${styles.card2} ${styles.secondary}`}>
            <div>
              <p><strong>Representante Legal (RL)</strong></p>
              <ul>
                <li>CPF</li>
                <li>Termo de guarda, tutela ou curatela da pessoa cadastrada</li>
                <li>Comprovante de endereço ou, na falta deste, declaração de residência assinada pelo RL.</li>
              </ul>
            </div>
          </Card>

          <img className={styles.imgPagina3} src={imgPagina3} alt="Imagem do rodapé" />
          <img className={styles.imgMoca3} src={imgMoca3} alt="Mulher em pé" />
        </div>

        <div className={styles.footer}>
          <div className={styles.botaoWrapper}>
            <BrButton className={styles.botao} onClick={() => setPage(4)}>
              Próximo
            </BrButton>
            <div className={styles.bulletPointWrapper}>
              <div onClick={() => setPage(1)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(2)} className={styles.bulletPoint}></div>
              <div
                onClick={() => setPage(3)}
                className={`${styles.bulletPoint} ${styles.selecionado}`}
              ></div>
              <div onClick={() => setPage(4)} className={styles.bulletPoint}></div>
            </div>
          </div>
        </div>

        <img className={styles.imgFundo} src={imgFundo} alt="Imagem de fundo" />
      </div>
    </div>
  );

  const pagina4 = (
    <div className={styles.container}>
      <div className={styles.containerScrollable}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>Postos de atendimento</div>
          <i className={`fas fa-times ${styles.close}`} onClick={() => history.goBack()}/>
        </div>
        <div className={styles.content}>
          <Card className={styles.card4}>
            <span>
              O(a) <strong>Responsável Familiar (RF)</strong> ou o(a){' '}
              <strong>Representante Legal (RL)</strong> deve ir ao <strong>CRAS</strong> ou posto de atendimento do{' '}
              <strong>Cadastro Único</strong> levando os <strong>documentos das pessoas da família.</strong>
              <br />
              <br />
              Esses postos normalmente funcionam nos Centros de Referência da Assistência Social (
              <strong>CRAS</strong>) ou nas sedes da secretaria de assistência social da{' '}
              <strong>prefeitura.</strong>
              <br />
              <br />
              Você pode buscar onde ficam os postos de atendimento <strong>mais próximos</strong> de você na opção{' '}
              <span className={styles.link} onClick={() => history.replace('/posto-atendimento')}>
                Postos de Atendimento
              </span>
              .
            </span>
          </Card>
          <img className={styles.imgPagina4} src={imgPagina4} alt="Imagem do rodapé" />
          <img className={styles.imgMoca4} src={imgMoca3} alt="Mulher em pé" />
        </div>
        <div className={styles.footer}>
          <div className={styles.botaoWrapper}>
            <BrButton className={styles.botao} onClick={() => history.goBack()}>
              Concluir
            </BrButton>
            <div className={styles.bulletPointWrapper}>
              <div onClick={() => setPage(1)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(2)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(3)} className={styles.bulletPoint}></div>
              <div onClick={() => setPage(4)} className={`${styles.bulletPoint} ${styles.selecionado}`}></div>
            </div>
          </div>
        </div>
        <img className={styles.imgFundo} src={imgFundo} alt="Imagem de fundo" />
      </div>
    </div>
  );

  return (
    <>
      {page === 1 && pagina1}
      {page === 2 && pagina2}
      {page === 3 && pagina3}
      {page === 4 && pagina4}
    </>
  );
};

export default ComoCadastrar;
